// @ts-check

// @ts-ignore
import { registerSingleton } from 'fe-lib-singleton';

import { UNSAFE_getThemeValue } from './getThemeValue';
import { subscribe, getState } from './store';
import { warning } from './util/warning';
import {
  getIsBrand2020Active,
  getIsBrand2020Released,
  getIsBrand2020Forced,
  getIsOptedIn,
  shouldShowOptIn,
  shouldShowOptOut,
  shouldShowOptOutTour,
  shouldShowUITour,
  doOptIn,
  doOptOut,
  doFinishUITour,
  doFinishOptOutTour,
  useBrand2020Theme,
  useLegacyTheme,
} from './brand2020Rollout';
import { useRebrand2022Theme } from './rebrand2022Theme';

const NAMESPACE = 'fe-lib-theme-provider';

const getTheme = () => {
  warning(false, 'Detected an old version of fe-hoc-theme, upgrade to latest.');
  return getState();
};

export { UNSAFE_getThemeValue };

registerSingleton(NAMESPACE, {
  getThemeValue: UNSAFE_getThemeValue, // Rename function to avoid breaking current singleton
  getTheme, // TODO: FPLAt-288 deprecated, remove when no more usage warnings
  subscribe,

  getIsBrand2020Active,
  getIsBrand2020Released,
  getIsBrand2020Forced,
  getIsOptedIn,
  shouldShowOptIn,
  shouldShowOptOut,
  shouldShowUITour,
  shouldShowOptOutTour,
  doOptIn,
  doOptOut,
  doFinishUITour,
  doFinishOptOutTour,
  useBrand2020Theme,
  useLegacyTheme,
  useRebrand2022Theme,
});
